import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "margin": "16px"
  }
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 添加任务 ");

import { ref } from 'vue';
import taskListCmp from './components/taskList.vue';
export default {
  __name: 'App',

  setup(__props) {
    let id = 0;
    const task = ref('');
    const taskRef = ref(null);
    let taskList = ref([]);

    const onSubmit = values => {
      taskList.value.push({
        text: values.task,
        checked: false,
        isEdit: false,
        key: id++
      });
      task.value = '';
    };

    const deleteTaskItem = key => {
      taskList.value = taskList.value.filter(item => item.key !== key);
    };

    function markTaskItem(key) {
      taskList.value = taskList.value.map(item => {
        if (item.key === key) {
          return { ...item,
            checked: !item.checked,
            isEdit: false
          };
        } else {
          return item;
        }
      });
    }

    function editTaskItem(key) {
      taskList.value = taskList.value.map(item => {
        if (item.key === key) {
          return { ...item,
            isEdit: true
          };
        } else {
          return { ...item,
            isEdit: false
          };
        }
      });
    }

    function updateTaskItem(text, key) {
      taskList.value = taskList.value.map(item => {
        if (item.key === key) {
          return { ...item,
            text: text
          };
        } else {
          return item;
        }
      });
    }

    function blurTaskItem() {
      taskList.value = taskList.value.map(item => {
        return { ...item,
          isEdit: false
        };
      });
    }

    function clickNoDataItem() {
      taskRef.value.focus();
    }

    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");

      const _component_van_cell_group = _resolveComponent("van-cell-group");

      const _component_van_button = _resolveComponent("van-button");

      const _component_van_form = _resolveComponent("van-form");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(taskListCmp, {
        tasklist: _unref(taskList),
        onDeleteTask: deleteTaskItem,
        onMarkTask: markTaskItem,
        onEditTask: editTaskItem,
        onUpdateTask: updateTaskItem,
        onBlurTask: blurTaskItem,
        onClickNodata: clickNoDataItem
      }, null, 8, ["tasklist"]), _createVNode(_component_van_form, {
        onSubmit: onSubmit
      }, {
        default: _withCtx(() => [_createVNode(_component_van_cell_group, {
          inset: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            ref_key: "taskRef",
            ref: taskRef,
            modelValue: task.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => task.value = $event),
            name: "task",
            placeholder: "输入任务项",
            rules: [{
              required: true,
              message: '请输入任务项'
            }]
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_1, [_createVNode(_component_van_button, {
          round: "",
          block: "",
          type: "primary",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })])]),
        _: 1
      })], 64);
    };
  }

};